import React from 'react'
import { FormLabel as ChakraFormLabel, FormLabelProps } from '@chakra-ui/react'

export const FormLabel = (props: FormLabelProps) => (
  <ChakraFormLabel {...props} />
)
